import React from "react";
import "./Explore.css";
import ExploreGrid from "../ExploreGrid/ExploreGrid";

function Explore() {
  return (
    <div className="explore">
      <h1 style={{ textAlign: "center" }}>Explore our Mentors</h1>
      <ExploreGrid />
    </div>
  );
}

export default Explore;
